import { apiSlice } from "../../app/api/apiSlice";

export const newsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNews: builder.query({
      query: () => ({
        url: "/news",
        validateStatus: (response, result) =>
          response.status === 200 && !result.isError,
      }),
      // eslint-disable-next-line
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "News", id: "LIST" },
            ...result.ids.map((id) => ({ type: "News", id })),
          ];
        }
        return [{ type: "News", id: "LIST" }];
      },
    }),
    getNewsByStatus: builder.query({
      query: (status) => ({
        url: `/news/status/${status}`,
        validateStatus: (response, result) =>
          response.status === 200 && !result.isError,
      }),
      // eslint-disable-next-line
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "News", id: "LIST" },
            ...result.ids.map((id) => ({ type: "News", id })),
          ];
        }
        return [{ type: "News", id: "LIST" }];
      },
    }),
    getNewsById: builder.query({
      query: (newsId) => ({
        url: `/news/${newsId}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [{ type: "News", id: arg }],
    }),

    addNewNews: builder.mutation({
      query: (data) => ({
        url: "/news",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "News", id: "LIST" }],
    }),
    updateNews: builder.mutation({
      query: (newsUpdate) => ({
        url: "/news",
        method: "PATCH",
        body: {
          ...newsUpdate,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "News", id: arg.id }],
    }),
    archiveNew: builder.mutation({
      query: (newId) => ({
        url: "/news/archive", // Endpoint zum Archivieren
        method: "PATCH", // Verwende die PATCH-Methode für Updates
        body: { newId }, // newId wird im Body der Anfrage übergeben
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "News", id: arg.newId },
      ], // Korrigiere den Zugriff auf 'arg.newId'
    }),

    likeNews: builder.mutation({
      query: (id) => ({
        url: `/news/${id}/like`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, arg) => [{ type: "News", id: arg }],
    }),
    viewNews: builder.mutation({
      query: (id) => ({
        url: `/news/${id}/view`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, arg) => [{ type: "News", id: arg }],
    }),
    deleteNew: builder.mutation({
      query: (newId) => ({
        url: `/news`,
        method: "DELETE",
        body: { newId },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "News", id: arg.id }],
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetNewsByStatusQuery,
  useGetNewsByIdQuery,
  useArchiveNewMutation,
  useAddNewNewsMutation,
  useUpdateNewsMutation,
  useLikeNewsMutation,
  useViewNewsMutation,
  useDeleteNewMutation,
} = newsApiSlice;
